/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RptOpportunityDtoFromJSON, RptOpportunityDtoToJSON, } from './RptOpportunityDto';
/**
 * Check if a given object implements the RptOpportunityPagedDto interface.
 */
export function instanceOfRptOpportunityPagedDto(value) {
    return true;
}
export function RptOpportunityPagedDtoFromJSON(json) {
    return RptOpportunityPagedDtoFromJSONTyped(json, false);
}
export function RptOpportunityPagedDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'content': json['content'] == null ? undefined : (json['content'].map(RptOpportunityDtoFromJSON)),
        'size': json['size'] == null ? undefined : json['size'],
        'page': json['page'] == null ? undefined : json['page'],
        'totalElements': json['totalElements'] == null ? undefined : json['totalElements'],
        'totalPages': json['totalPages'] == null ? undefined : json['totalPages'],
    };
}
export function RptOpportunityPagedDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'content': value['content'] == null ? undefined : (value['content'].map(RptOpportunityDtoToJSON)),
        'size': value['size'],
        'page': value['page'],
        'totalElements': value['totalElements'],
        'totalPages': value['totalPages'],
    };
}
